import TopBar from "./components/TopBar";
import SiteHeader from "./components/SiteHeader";
import Hero from "./components/Hero";
import HeatTicker from "./components/HeatTicker";
import HotRanking from "./components/HotRanking";
import TrendPanel from "./components/TrendPanel";
import FocusTopics from "./components/FocusTopics";
import ResourceEntries from "./components/ResourceEntries";
import TopicCategories from "./components/TopicCategories";
import SubscribeBanner from "./components/SubscribeBanner";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <TopBar />
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HeatTicker />
        <HotRanking />
        <TrendPanel />
        <FocusTopics />
        <ResourceEntries />
        <TopicCategories />
        <SubscribeBanner />
      </main>
      <SiteFooter />
    </div>
  );
}